import ExpandCards from '@/app/components/ExpandCards';
import * as S from './styles';
import { useTranslation } from 'react-i18next';

const Faq = () => {
  const { t } = useTranslation();

  const DATA_FAQ = [
    {
      title: t('MMRPage.faq.warning'),
      description: (
        <S.Description>
          <p>{t('MMRPage.faq.warningDescription')}</p>
          <p>{t('MMRPage.faq.warningDescription1')}</p>
          <p>{t('MMRPage.faq.warningDescription2')}</p>
          <p>{t('MMRPage.faq.warningDescription3')}</p>
        </S.Description>
      ),
    },
  ];

  return <ExpandCards items={DATA_FAQ} />;
};

export default Faq;
